<div class='delete-customization'>
    <div class='delete-customization__title'>{{ 'COMMON.DELETE_CUSTOMIZATION_MODAL.TITLE' | translate }}</div>
    <div class='delete-customization__description'>{{ 'COMMON.DELETE_CUSTOMIZATION_MODAL.DESCRIPTION' | translate }}</div>
    <app-button
      class='delete-customization__continue-button'
      buttonText="{{ 'COMMON.DELETE_CUSTOMIZATION_MODAL.BUTTON_CONTINUE' | translate }}"
      (click)='continue()'
      type='delete-customization'
    ></app-button>
    <div class='delete-customization__cancel-button' (click)='cancel()'>{{ 'COMMON.DELETE_CUSTOMIZATION_MODAL.BUTTON_CANCEL' | translate }}</div>
</div>
